"use client"

import { motion } from "framer-motion"

const whatsappNumber = "201031699339"
const message = "Hello! I'm interested in learning more about Dhikr Institute courses."

const WhatsappIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    className="w-6 h-6"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M16 2.667c-7.354 0-13.333 5.98-13.333 13.333c0 2.349.612 4.632 1.778 6.667L3.333 29.333l6.8-1.973A13.27 13.27 0 0 0 16 29.333c7.353 0 13.333-5.979 13.333-13.333S23.353 2.667 16 2.667Zm0 24a10.62 10.62 0 0 1-5.453-1.56l-.389-.233l-4.04 1.174l1.18-3.945l-.254-.406A10.62 10.62 0 0 1 5.333 16C5.333 9.72 10.387 4.667 16 4.667S26.667 9.72 26.667 16S21.613 26.667 16 26.667Zm6.053-7.8c-.333-.18-1.953-.96-2.257-1.073c-.303-.112-.525-.167-.747.113c-.223.28-.858 1.073-1.052 1.293c-.193.22-.387.233-.72.053c-.334-.18-1.409-.52-2.687-1.656c-.993-.883-1.663-1.973-1.856-2.306c-.193-.333-.02-.513.146-.693c.15-.167.334-.433.5-.647c.167-.213.223-.367.334-.614c.112-.247.056-.46-.028-.64c-.084-.18-.747-1.8-1.027-2.473c-.27-.653-.546-.567-.746-.58c-.193-.013-.414-.013-.64-.013c-.223 0-.587.086-.894.433c-.307.346-1.173 1.147-1.173 2.8c0 1.653 1.2 3.247 1.367 3.467c.167.22 2.36 3.607 5.72 5.053c.8.347 1.427.553 1.92.707c.807.257 1.54.22 2.12.134c.647-.1 1.953-.8 2.227-1.573c.274-.773.274-1.44.193-1.573c-.08-.133-.307-.213-.64-.393Z"
    />
  </svg>
)

export function FloatingWhatsApp() {
  
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1, duration: 0.3 }}
      className="fixed bottom-6 right-6 z-50"
    >
      <div className="relative">
        <span className="pointer-events-none absolute inset-0 rounded-full bg-[#25D366] opacity-20 animate-ping" aria-hidden="true" />
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="relative flex items-center gap-3 bg-[#25D366] hover:bg-[#128C7E] text-white rounded-full shadow-2xl transition-all duration-300 hover:shadow-3xl hover:scale-105 py-4 pl-5 pr-6"
          aria-label="Chat with Dhikr Institute on WhatsApp"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-white/15">
            <WhatsappIcon />
          </span>
          <span className="font-semibold text-sm tracking-wide uppercase">Get Offer</span>
        </a>
      </div>
    </motion.div>
  )
}
